module.exports = __webpack_public_path__ + "img/marker-icon-2x-gold.7abc2e93.png";